import { render, staticRenderFns } from "./CompletedPurchase.vue?vue&type=template&id=618a400c&"
import script from "./CompletedPurchase.vue?vue&type=script&lang=js&"
export * from "./CompletedPurchase.vue?vue&type=script&lang=js&"
import style0 from "./CompletedPurchase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports